import { Switch, TextField } from "@vividtheory/minerva-lab";
import { matchFilter } from "../utils";
import React from "react";
const BooleanDataInputField = ({ filters, handleInputDataChange, }) => {
    return (React.createElement(Switch, { defaultChecked: filters.data, switched: filters.data, onSwitchChange: () => {
            handleInputDataChange(!filters.data);
        } }));
};
const StringDataInputField = ({ handleInputDataChange, filters, }) => {
    return (React.createElement(TextField, { fullWidth: true, onChange: (e) => {
            handleInputDataChange((e === null || e === void 0 ? void 0 : e.target.value) || "");
        }, value: filters.data }));
};
const NumberDataInputField = ({ handleInputDataChange, filters, }) => {
    return (React.createElement(TextField, { fullWidth: true, type: "number", onChange: (e) => {
            handleInputDataChange(Number((e === null || e === void 0 ? void 0 : e.currentTarget.value) || 0));
        }, value: String(filters.data) }));
};
export const FilterInputField = ({ filters, handleInputDataChange, }) => {
    const matchAndRender = (f, handleInputDataChange) => matchFilter(f, {
        boolean: (f) => (React.createElement(BooleanDataInputField, { filters: f, handleInputDataChange: handleInputDataChange })),
        number: (f) => (React.createElement(NumberDataInputField, { filters: f, handleInputDataChange: handleInputDataChange })),
        string: (f) => (React.createElement(StringDataInputField, { filters: f, handleInputDataChange: handleInputDataChange })),
        multiSelect: (_f) => (
        // TODO Update when spec is finished
        React.createElement(React.Fragment, null, "multiSelect")),
        date: () => (
        // TODO Update when spec is finished
        React.createElement(React.Fragment, null, "date")),
    });
    return matchAndRender(filters, handleInputDataChange);
};
//# sourceMappingURL=FilterInputField.js.map